import Action from 'actions';
import BaseLP from 'services/sports/default/base-lp';

export default class LpTiers extends BaseLP {
    createGroupsOfStacks({incomingValues: {dispatch}}) {
        const {
            playersData: {preparedPlayers},
        } = Action.getState();
        dispatch(Action.do('createGroupsOfPositionStacks', preparedPlayers.groupedBy.teamAndPosition()));
    }

    subjectToPermanent() {
        const constraints = {
            tiers: this.exec('prepareSectionByTier', {}, ''),
            games: this.exec('prepareSectionByGame', {}, ''),
            keyPlayerStacking: this.exec('keyPlayerStacking', {}, ''),
            projectionBoostRule: this.exec('projectionBoostRule', {}, ''),
        };

        return {...constraints};
    }

    subjectToAlterable() {
        const constraints = {
            createdLineups: this.exec('prepareSectionByCreatedLineups_Tiers', {}, ''),
            exposureMax: this.exec('prepareSectionByExposureMax', {}, ''),
            exposureMin: this.exec('prepareSectionByExposureMin', {}, ''),
            playerCombinationStacking: this.exec('playerCombinationStacking', {}, ''),
        };

        return {...constraints};
    }
}
